import React from 'react';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { QuotationImportWizard } from 'features/salesOrder/quotationImport/components/QuotationImportWizard';

export const QuotationImportPage = (): JSX.Element => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<Layout>
			<Grid container paddingY={isMobile ? 2 : 5} justifyContent="center">
				<Grid item xs={12} md={10} lg={8} px={isMobile ? 2 : 0}>
					<QuotationImportWizard />
				</Grid>
			</Grid>
		</Layout>
	);
};
